
import React from "react";
import { Button, Card, CardBody, CardFooter, CardTitle, InputGroup, InputGroupText, Input, Row, Col } from "reactstrap";
import * as utility from 'components/Utils';


class Solar extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			isAuthorized: localStorage.getItem('isAuthorized'),
			password: '',
			totalPower: 0,
			units: '',
		}

		// localStorage.removeItem('isAuthorized');	// requires new authentication for the protected areas

		this.handleAuthorizationPassword = this.handleAuthorizationPassword.bind(this);
		this.getSolar = this.getSolar.bind(this);
	}

	componentDidMount() {
		this.getSolar();
		this.intervalSolar = setInterval(() => this.getSolar(), 5*60*1000);	// every 5 minutes update the solar power value
	}

	componentWillUnmount() {
		clearInterval(this.intervalSolar);
	}

	handleAuthorizationPassword( event ) {
		event.preventDefault();

		if ( this.state.password === '00' ) {
			this.setState( { isAuthorized: true } );
			localStorage.setItem('isAuthorized', true );
		}
	}

	setPassword(val) {
		this.setState( { password: val } );
	}


	loginFirst() {
		return (
			<div className="Login">
			  <form onSubmit={this.handleAuthorizationPassword}>
				<InputGroup name="password">
				  <InputGroupText> Unlock Code </InputGroupText>
				  <Input
					value={this.state.password}
					onChange={e => this.setPassword(e.target.value)}
				  />
				</InputGroup>
				<Button block type="submit">
				  Login
				</Button>
			  </form>
			</div>
		);

	}

	getSolar() {
		const url = utility.getRootUrl()+'/solar-now.php';

		// console.log("url: " + url );

		fetch(url)
			.then(function (response) {
				// console.log(url + " -> " + response.ok);
				return response.json();
			})
			.then(function (data) {
				// console.log("data: "); console.dir(data);
				this.setState({ totalPower: data.totalPower, units: data.units });
			}.bind(this))
			.catch(function (err) {
				console.log("failed to load ", url, err.stack);
			});
	}



	render() {

		if ( ! this.state.isAuthorized ) {
			return (
			<div className="content"
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}>
				{this.loginFirst()}
			</div>
			);
		}

		return (
		  <>
			<div className="content">

			<h5 className="title"> Solar </h5>

			<br />

			  <Row>

				<Col lg="3" md="4" sm="6">
				  <Card className="card-stats">
					<CardBody>
					  <Row>
						<Col md="4" xs="5">
						  <img alt="Temp" height="60" src="/sun.svg" />
						</Col>
						<Col md="8" xs="4">
						  <div className="numbers">
							<p className="card-category"> Current Power Generating </p>
							<CardTitle tag="p">
								<div className="livingroom-temperature"> { this.state.totalPower } { this.state.units } </div>
								</CardTitle>
							<p />
						  </div>
						</Col>
					  </Row>
					</CardBody>
					<CardFooter>
					  <hr />
					  <div className="stats">
						for new APS system 
					  </div>
					</CardFooter>
				  </Card>
				</Col>

			  </Row>

			</div>

		  </>
		);
	}
}

export default Solar;
